import { LoadingButton } from "@mui/lab";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { queryClient } from "@ssf/components";
import { useMutation } from "@tanstack/react-query";
import { Close } from "mdi-material-ui";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { removeSignatureMutation } from "../lib/index.js";

export const SignatureRemoveButton = ({
  signatureId,
}: {
  signatureId: string;
}) => {
  const { t } = useTranslation("SignatureRemoveButton");
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { mutate: removeSignature, isPending } = useMutation({
    ...removeSignatureMutation,
    onSuccess() {
      setOpen(false);
      enqueueSnackbar(t("success"), { variant: "success" });
      queryClient.invalidateQueries();
    },
  });

  return (
    <>
      <Tooltip title={t("action")}>
        <IconButton
          size="small"
          sx={{ mr: -1 }}
          onClick={() => setOpen(true)}
          disabled={isPending}
        >
          {isPending ? (
            <CircularProgress color="inherit" size={16} />
          ) : (
            <Close fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t("confirmTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("confirmMessage")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="inherit">
            {t("cancel")}
          </Button>
          <LoadingButton
            onClick={() => removeSignature(signatureId)}
            loading={isPending}
            variant="contained"
          >
            {t("action")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
